<template>
	<div class="animated fadeIn" :class="$screen.width > 576 ? 'container-layout' : 'container-mobile'">
		<b-form @submit.prevent="submitForm">
			<b-row class="mb-2">
				<b-col>
					<fieldset :class="`${$screen.width <= 576 ? 'card-inside my-0 py-0 pb-0' : 'scheduler-border'}`">
						<legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`" class="text-color-rhapsody-in-blue-2">
							{{ FormMSG(1, 'General') }}
						</legend>
						<b-row :class="`${$screen.width <= 576 ? '' : 'py-2'}`">
							<b-col>
								<b-form-group :label="FormMSG(4, 'Category')">
									<b-form-input type="text" v-model="flag.name" disabled></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
					</fieldset>
				</b-col>
			</b-row>
			<b-row :class="`${$screen.width <= 992 ? 'mt-2 pb-4' : 'mt-2 pb-2'}`">
				<b-col>
					<fieldset :class="`${$screen.width <= 576 ? 'card-inside my-0 py-0 pb-0' : 'scheduler-border'}`">
						<legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`" class="text-color-rhapsody-in-blue-2">
							{{ forAllowances ? FormMSG(3100, 'Allowances') : FormMSG(300, 'Per Diem') }}
						</legend>
						<b-row class="mt-2">
							<b-col>
								<div class="text-center pb-3 mb-2" style="font-size: 1rem" v-if="$screen.width < 992 && flag.projectFlagItem.length === 0">
									{{
										forAllowances ? FormMSG(1454, 'Please, add a new custom allowances') : FormMSG(140, 'Please, add a new custom per diem')
									}}
								</div>
								<b-table-simple small :borderless="true" v-if="$screen.width >= 992 && flag.projectFlagItem.length > 0">
									<b-thead style="color: rgba(6, 38, 62, 0.84)">
										<b-tr style="line-height: 8px">
											<b-th v-if="action === 'UPDATE' && flag.projectFlagItem.length > 0"></b-th>
											<b-th style="text-align: center">#</b-th>
											<b-th>{{ FormMSG(9, 'Name') }}</b-th>
											<b-th v-if="!forAllowances">{{ FormMSG(10, 'Abbreviation') }}</b-th>
											<b-th>{{ FormMSG(100, 'Amount') }}</b-th>
											<b-th v-if="forAllowances"></b-th>
											<b-th>{{ FormMSG(101, 'Category') }}</b-th>
											<b-th>{{ FormMSG(102, 'Pay code') }}</b-th>
											<b-th>{{ FormMSG(105, 'Grouping category') }}</b-th>
											<b-th>{{ FormMSG(106, 'Perso') }}</b-th>
											<b-th v-if="!forAllowances">{{ FormMSG(103, 'Color') }}</b-th>
											<b-th v-if="!forAllowances">{{ FormMSG(104, 'Bookmark') }}</b-th>
											<b-th></b-th>
										</b-tr>
									</b-thead>
									<b-tbody class="text-center">
										<finance-table-custom-item-form
											v-for="(item, i) in flag.projectFlagItem"
											:ref="generateTextId(`item-form-${i}`)"
											:key="i"
											:index="i"
											:item="item"
											:for-allowances="forAllowances"
											:existDataAlreadySubmitted="existDataAlreadySubmitted"
											@finance-table-flag-item-form:updated="onLineTableChanged"
											@finance-table-flag-item-form:removed="onLineTableRemoved"
										/>
									</b-tbody>
								</b-table-simple>
								<div class="text-center pb-3" style="font-size: 1rem" v-if="$screen.width >= 992 && flag.projectFlagItem.length === 0">
									{{
										forAllowances ? FormMSG(1454, 'Please, add a new custom allowances') : FormMSG(140, 'Please, add a new custom per diem')
									}}
								</div>
							</b-col>
						</b-row>
						<b-row class="mb-2 pb-3">
							<div class="d-flex justify-content-end" style="width: 93.5%; margin: -10px 0 0 0">
								<b-button size="sm" variant="outline-primary" class="d-flex justify-content-center align-items-center" @click="addNewFlag">
									<component :is="getLucideIcon('PlusCircle')" :size="16" :stroke-width="2" />
									<div class="px-2" style="margin-bottom: -2px">
										{{ forAllowances ? FormMSG(1263, 'Add new custom allowances') : FormMSG(110, 'Add new custom per diem') }}
									</div>
								</b-button>
							</div>
						</b-row>
					</fieldset>
				</b-col>
			</b-row>
			<b-row>
				<b-col
					class="d-flex justify-content-center mt-2"
					sm="4"
					md="4"
					lg="4"
					xl="4"
					offset-sm="5"
					offset-md="5"
					offset-lg="5"
					offset-xl="5"
					:style="`display: ${displayAddBtn ? 'block' : 'none'} !important;`"
				>
					<b-button ref="submit" type="submit" size="md" variant="outline-primary" class="w-138-px" block>{{ FormMSG(13, 'Save') }}</b-button>
				</b-col>
			</b-row>
		</b-form>
		<b-modal
			header-class="header-class-modal-doc-package"
			header-bg-variant="warning"
			:title="this.FormMSG(18, 'Warning')"
			class="modal-warning"
			v-model="warningMissingFlagItemModal"
			@ok="warningMissingFlagItemModal = false"
			ok-variant="warning"
			ok-only
			modal-class="mui-animation"
			:fade="false"
		>
			<div style="font-size: 1rem">
				{{ FormMSG(19, 'Please fill the field(s) required (coloring red) in flags section or remove one or all of them.') }}
			</div>
		</b-modal>
	</div>
</template>
<script>
import LanguageMessages from '@/mixins/languageMessages';
import GlobalMixin from '@/mixins/global.mixin';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { addUpdateProjectFlag, addUpdateProjectFlagItem, deleteProjectFlagItem } from '@/cruds/flag.crud';
import FinanceTableCustomItemForm from '@/components/Finance/TableCustomForm';
import { generateSecureId } from '@/shared/utils';
import { ACTION, FLAG_TYPE } from '@/shared/constants';

export default {
	name: 'PerDiemForm',
	mixins: [LanguageMessages, GlobalMixin, validationMixin],
	components: {
		FinanceTableCustomItemForm
	},
	props: {
		action: {
			type: String,
			required: true,
			default: ACTION.ADD // ADD, UPDATE
		},
		displayAddBtn: {
			type: Boolean,
			required: false,
			default: true
		},
		item: {
			type: Object,
			required: false,
			default: () => {}
		},
		forAllowances: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	computed: {
		perDiemTxt() {
			return this.forAllowances ? this.FormMSG(1518, 'Allowance') : this.FormMSG(1515, 'Per Diem');
		},
		flagFields() {
			return [
				{
					key: 'disabled',
					label: this.FormMSG(22, 'Disable ?'),
					class: 'text-center',
					isSlot: true
				},
				{
					key: 'name',
					label: this.FormMSG(9, 'Name'),
					class: 'text-center',
					isSlot: true,
					required: true
				},
				{
					key: 'short',
					label: this.FormMSG(10, 'Abbreviation'),
					class: 'text-center',
					isSlot: true,
					required: true
				}
			];
		}
	},
	data() {
		return {
			flag: {
				id: 0,
				name: '',
				short: '',
				decription: '',
				greenFlag: false,
				projectFlagItem: []
			},
			isSubmitted: false,
			// flags: [],
			isValidFlags: [],
			warningMissingFlagItemModal: false,
			existDataAlreadySubmitted: false,
			validatorPatterns: {
				name: {
					required,
					min: minLength(3)
				},
				short: {
					required
				},
				amount: {
					required
				},
				category: {
					required
				},
				payCode: {
					required
				}
			},
			addUpdFlagItems: []
		};
	},
	methods: {
		async submitForm(e) {
			e.preventDefault();
			this.isSubmitted = true;

			// this.$v.$touch();
			// if (this.$v.$invalid || !this.validFlags()) {
			// 	if (!this.validFlags()) {
			// 		this.warningMissingFlagItemModal = true;
			// 	}
			// 	return;
			// }
			await this.manageAction(+this.flag.id);
		},
		async manageAction(id) {
			// console.log(this.addUpdFlagItems);

			this.$emit('finance-flag-form:waiting', true);
			//type = 3 => allowance //// type = 4 => perDiem
			let allowType = this.flag.type;
			await addUpdateProjectFlag(+id, {
				type: allowType
			})
				.then(async (record) => {
					for (const flagItem of this.addUpdFlagItems) {
						let item = flagItem;
						if (+flagItem.id === 0) {
							item.flagId = record.flagId;
						} else {
							item = {
								disabled: flagItem.disabled,
								...item,
								flagId: null,
								value: null
							};
						}

						await addUpdateProjectFlagItem(+flagItem.id, item).catch((error) => {
							console.error({ error });
						});
					}
				})
				.catch((error) => {
					console.error({ error });
				})
				.finally(() => {
					let message = '';
					if (this.action === ACTION.ADD) {
						message =
							this.flag.projectFlagItem.length === 0
								? this.FormMSG(16, 'Flag category created successfully, but you need to create flags later.')
								: this.FormMSG(17, 'Flag category and flags created successfully.');
					} else if (this.action === ACTION.UPDATE) {
						message =
							this.flag.projectFlagItem.length === 0
								? this.FormMSG(20, 'Flag category updated successfully, but you need to create flags later.')
								: this.FormMSG(21, 'Flag category and flags updated successfully.');
					}
					this.$emit('finance-flag-form:waiting', false);
					this.$emit('finance-flag-form:close-modal', message);
				});
		},
		onLineTableChanged({ index, item, isLineValid }) {
			if (this.addUpdFlagItems.length === 0) {
				this.addUpdFlagItems.push({
					...item,
					index
				});
			} else {
				const idx = this.addUpdFlagItems.findIndex((flagItem) => flagItem.index === index);
				if (idx === -1) {
					this.addUpdFlagItems.push({
						...item,
						index
					});
				} else {
					this.addUpdFlagItems[idx] = Object.assign(this.addUpdFlagItems[idx], item);
				}
			}

			this.isValidFlags[index] = isLineValid;
		},
		onLineTableRemoved({ index, id }) {
			if (id === 0) {
				this.flag.projectFlagItem.splice(index, 1);
				const idx = this.addUpdFlagItems.findIndex((flagItem) => flagItem.index === index);
				if (idx !== -1) {
					this.addUpdFlagItems.splice(idx, 1);
				}
				this.isValidFlags.splice(index, 1);
			} else {
				const action = async () => {
					await deleteProjectFlagItem(id)
						.then((result) => {
							if (result) {
								this.flag.projectFlagItem.splice(index, 1);
								const idx = this.addUpdFlagItems.findIndex((flagItem) => flagItem.index === index);
								if (idx !== -1) {
									this.addUpdFlagItems.splice(idx, 1);
								}
								this.isValidFlags.splice(index, 1);

								this.$emit('finance-flag-form:reload', true);
							}
						})
						.catch((e) => {
							console.error({ e });
						});
				};
				this.confirmModal(action, this.FormMSG(15, 'Are you sure to remove this flag ?'), 'danger');
			}

			if (this.flag.projectFlagItem.length === 0) {
				this.existDataAlreadySubmitted = false;
			} else {
				const existTrueData = this.flag.projectFlagItem.filter((flagItem) => +flagItem.id > 0);
				this.existDataAlreadySubmitted = existTrueData.length > 0;
			}
		},
		addNewFlag() {
			const flagItem = {
				id: 0,
				flagId: 0,
				value: 5,
				name: '',
				short: '',
				amount: 0,
				allowanceRate: 0,
				category: 0,
				payCode: null,
				color: 'ff0000',
				bookmark: false,
				groupingCategory: 0
			};
			this.forAllowances ? (flagItem.value = 6) : (flagItem.value = 5);
			this.flag.projectFlagItem.push(flagItem);
			this.isValidFlags.push(false);
		},
		generateTextId(id) {
			return generateSecureId(id);
		},
		validFlags() {
			if (this.isValidFlags.length === 0) return true;
			let isValidFlags = this.isValidFlags.join(',');

			return !/false/.test(isValidFlags);
		},
		checkboxTitle(item) {
			return item.disabled === false ? this.FormMSG(23, 'Disable') : this.FormMSG(24, 'Enable');
		},
		handleInputChanged(payload, fieldName, index, isLineValid) {
			if (this.addUpdFlagItems.length === 0) {
				let flagItem = this.flag.projectFlagItem[index];
				flagItem[fieldName] = payload;
				this.addUpdFlagItems.push({
					...flagItem,
					index
				});
			} else {
				const idx = this.addUpdFlagItems.findIndex((flagItem) => flagItem.index === index);
				if (idx === -1) {
					let flagItem = this.flag.projectFlagItem[index];
					flagItem[fieldName] = payload;
					this.addUpdFlagItems.push({
						...flagItem,
						index
					});
				} else {
					this.addUpdFlagItems[idx][fieldName] = payload;
				}
			}

			this.isValidFlags[index] = isLineValid;
		},
		handleCheckboxChanged(payload, fieldName, index) {
			if (this.addUpdFlagItems.length === 0) {
				let flagItem = this.tax.projectFlagItem[index];
				flagItem[fieldName] = payload;

				this.addUpdFlagItems.push({
					...flagItem,
					index
				});
			} else {
				const idx = this.addUpdFlagItems.findIndex((flagItem) => flagItem.index === index);
				if (idx === -1) {
					let flagItem = this.tax.projectFlagItem[index];

					flagItem[fieldName] = payload;

					this.addUpdFlagItems.push({
						...flagItem,
						index
					});
				} else {
					this.addUpdFlagItems[idx][fieldName] = payload;
				}
			}
		}
	},
	watch: {
		item: {
			handler(value) {
				if (this.action === ACTION.UPDATE) {
					if (!_.isNil(value)) {
						this.flag = _.cloneDeep(value);
						if (this.flag.projectFlagItem.length > 0) {
							this.flag.projectFlagItem.forEach(() => {
								this.isValidFlags.push(true);
								this.existDataAlreadySubmitted = true;
							});
						}
					}
				}
			},
			deep: true,
			immediate: true
		}
	},
	validations() {
		return {
			flag: {
				name: {
					required,
					min: minLength(3)
				}
			}
		};
	}
};
</script>
<style lang="scss" scoped></style>
